import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "account-kpis" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_3 = {
  key: 2,
  class: "row g-2"
}
const _hoisted_4 = { class: "col-sm-6 col-lg-3" }
const _hoisted_5 = { class: "col-sm-6 col-lg-3" }
const _hoisted_6 = { class: "col-sm-6 col-lg-3" }
const _hoisted_7 = { class: "col-sm-6 col-lg-3" }

import { computed } from 'vue';
import KpiCard from './KpiCard.vue';
import KpiSkeletonRow from './KpiSkeletonRow.vue';
import LowBudgetKpiCard from './LowBudgetKpiCard.vue';
import { hasBudget } from '../utils/budget.js';


export default {
  __name: 'AccountKpis',
  props: {
  students: {
    type: Array,
    required: true,
  },
  employees: {
    type: Array,
    required: true,
  },
  /** Low-budget students, most critical first. */
  lowBudgetStudents: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: [Object, Error, String],
    default: null,
  },
},
  setup(__props) {

const props = __props;

const errorMessage = computed(() => {
  if (!props.error) return '';
  if (typeof props.error === 'string') return props.error;
  return props.error.message || 'Fehler beim Laden der Daten';
});

const studentHasActivity = (student) => hasBudget(student) || Boolean(student?.hasBookings);

const activeStudents = computed(() => {
  return props.students.filter(studentHasActivity).length;
});

const totalEmployees = computed(() => props.employees.length);

const budgetUtilization = computed(() => {
  const studentsWithBudget = props.students.filter(hasBudget);

  if (studentsWithBudget.length === 0) return 0;

  const totalUsed = studentsWithBudget.reduce((sum, student) => {
    return sum + (student.budget?.used || 0);
  }, 0);

  const totalBudget = studentsWithBudget.reduce((sum, student) => {
    return sum + (student.budget?.total || 0);
  }, 0);

  if (totalBudget === 0) return 0;

  return Math.round((totalUsed / totalBudget) * 100);
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
          _createTextVNode(" " + _toDisplayString(errorMessage.value), 1 /* TEXT */)
        ]))
      : (__props.loading)
        ? (_openBlock(), _createBlock(KpiSkeletonRow, { key: 1 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createCommentVNode(" Active Students "),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(KpiCard, {
                title: "Studenten",
                icon: "fas fa-graduation-cap",
                "icon-color-class": "text-primary"
              }, {
                footer: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "text-muted small" }, " mit Budget oder Buchungshistorie ", -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(activeStudents.value) + " ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createCommentVNode(" Active Employees "),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(KpiCard, {
                title: "Mitarbeiter",
                icon: "fas fa-user-tie",
                "icon-color-class": "text-success"
              }, {
                footer: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "text-muted small" }, " aktiv (mit Vertrag) ", -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(totalEmployees.value) + " ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createCommentVNode(" Low Budget Students "),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(LowBudgetKpiCard, { students: __props.lowBudgetStudents }, null, 8 /* PROPS */, ["students"])
            ]),
            _createCommentVNode(" Budget Utilization "),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(KpiCard, {
                title: "Budgetauslastung",
                icon: "fas fa-chart-line",
                "icon-color-class": "text-info"
              }, {
                footer: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "text-muted small" }, [
                    _createTextVNode(" Verbrauch / Total "),
                    _createElementVNode("i", {
                      class: "fas fa-info-circle ms-1",
                      title: "Durchschnittliche Budgetauslastung aller Studenten mit Budget",
                      "data-bs-toggle": "tooltip"
                    })
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(budgetUtilization.value) + "% ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]))
  ]))
}
}

}